import apiSlice from "./apiSlice";

const scheduleDashboardApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getScheduleProgressKpi: builder.query({
            query: ({ projectId }) => ({
                url: `schedule/progress-kpi`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ScheduleProgressKpi"],
        }),

        getScheduleProgressCurve: builder.query({
            query: ({ projectId }) => ({
                url: `schedule/progress-curve`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ScheduleProgressCurve"],
        }),

        getPlanVsActual: builder.query({
            query: ({ projectId }) => ({
                url: `schedule/plan-vs-actual`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["PlanVsActual"],
        }),

        getSchedulePerformance: builder.query({
            query: ({ projectId }) => ({
                url: `schedule/schedule-performance`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["SchedulePerformance"],
        }),

        getVarianceDrivers: builder.query({
            query: ({ projectId, period }) => ({
                url: `schedule/variance-drivers`,
                params: { projectId, period },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["VarianceDrivers"],
        }),
        getOntimeVsDelayed: builder.query({
            query: ({ projectId }) => ({
                url: `milestone/ontime-delay`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["OntimeVsDelayed"],
        }),
    }),
});

export const {
    useGetScheduleProgressKpiQuery,
    useGetScheduleProgressCurveQuery,
    useGetPlanVsActualQuery,
    useGetSchedulePerformanceQuery,
    useGetVarianceDriversQuery,
    useGetOntimeVsDelayedQuery
} = scheduleDashboardApiSlice;
